<div id="content">
  <div class="page-title">
    <app-company-product-page-identity />
    <h1>{{ page_title }}</h1>
    @if (can_manage_teams()) {
      <button mat-flat-button color="accent" (click)="add()">
        <mat-icon>add</mat-icon>
        Crear
      </button>
    }
  </div>

  <div class="bisual-table">
    <div class="bisual-table-container">
      <table mat-table [dataSource]="data_source">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Equipo</th>
          <td mat-cell *matCellDef="let pt">{{ pt.name }}</td>
        </ng-container>

        <ng-container matColumnDef="users">
          <th mat-header-cell *matHeaderCellDef>Usuarios</th>
          <td mat-cell *matCellDef="let pt">
            <button
              type="button"
              class="team-users-trigger"
              (click)="openTeamMembersDialog(pt)"
              [attr.aria-label]="usersLabel(pt) + ': ver miembros'"
            >
              <mat-icon>group</mat-icon>
              <span>{{ usersLabel(pt) }}</span>
              <mat-icon class="team-users-trigger__chevron">chevron_right</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="phases">
          <th mat-header-cell *matHeaderCellDef>Fases</th>
          <td mat-cell *matCellDef="let pt">{{ phasesLabel(pt) }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let pt; let i = index">
            @if (can_manage_teams()) {
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="edit(pt)">
                  <mat-icon>edit</mat-icon>
                  <span>Editar</span>
                </button>
                <button mat-menu-item (click)="delete(pt)">
                  <mat-icon>delete</mat-icon>
                  <span>Eliminar</span>
                </button>
              </mat-menu>
            }
          </td></ng-container
        >

        <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayed_columns"></tr>
      </table>
    </div>
  </div>
</div>
